<script>
  import { onMount } from "svelte";
  import { Link } from "svelte-routing";
  import emailjs from "@emailjs/browser";
  let scrollingImage12;

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    console.log("✅ EmailJS initialized");

    window.addEventListener("scroll", handleScroll12);
    return () => {
      window.removeEventListener("scroll", handleScroll12);
    };
  });

  function handleScroll12() {
    const scrollLeft = window.scrollY;
    const scalingFactor = 0.5;
    if (scrollingImage12) {
      scrollingImage12.style.transform = `translateX(-${scrollLeft * scalingFactor}px)`;
    }
  }

  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    console.log("📤 Sending email via EmailJS...");
    console.log("Service ID: service_3137pxo");
    console.log("Template ID: template_kxc76ui");
    console.log("Payload:", payload);

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.");
      console.error("Error status:", err.status);
      console.error("Error text:", err.text);
      console.error("Full error:", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  function handleScroll() {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;
    const element = document.getElementById("footerImage");
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // Calculate the distance scrolled since the last scroll event
    const scrollDistance = currentScrollPos - prevScrollPos;

    // Calculate the scaling factor based on the scroll direction
    const scaleIncrement = scrollDistance > 0 ? 0.01 : -0.01;

    // Adjust the scale of the image
    const currentScale =
      parseFloat(
        element.style.transform.replace("scale(", "").replace(")", "")
      ) || 1;
    const newScale = Math.max(
      0.5,
      Math.min(1.2, currentScale + scaleIncrement)
    ); // Limit the scale between 0.5 and 1.5

    // Update the scale of the image
    element.style.transform = `scale(${newScale})`;

    // Update previous scroll position
    prevScrollPos = currentScrollPos;
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="serv1">
  <div class="image-container1">
    <img src="/img/12.jpg" alt="Background Image" />
  </div>
  <div class="content1">
    <h4 class="services-heading">CONTACT</h4>
    <h1>We’re here to help</h1>
    <div class="contact-info-container">
      <div class="lefc">
        <p class="services-description">
          Call us at:
          <br />
          <span class="contact-info">76 361 951</span>
        </p>
      </div>
      <div class="rightc">
        <p class="services-description">
          Email us:
          <br />
          <span class="contact-info">Info@craft2code.com</span>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- <div class="pagewrap">
  <div class="container">
    <img src="/img/service.png" alt="Background Image" class="full-width" />
  </div>
</div> -->

<div class="ho3">
  <div class="content">
    <h2>Our locations</h2>
    <p class="bottom-left-text">
      We have offices throughout the East Coast, Midwest,<br /> and South — we’d
      love to show you around sometime.<br /> Don’t see an office in your area?
      We have the power to<br /> support your business, no matter the location.
    </p>
  </div>
  <div class="right23">
    <img
      src="/img/cnn1.png"
      alt="Image"
      id="scrollingImage"
      bind:this={scrollingImage12}
    />
  </div>
</div>

<div class="card-container1">
  <div class="card1">
    <i class="fas fa-map-marker-alt"></i>
    <h2>Lebanon</h2>
    <h4>Bouchrieh</h4>
    <p>
      New Rawda Street,<br />Egety Building<br />Bouchrieh, Lebanon
    </p>
    <a
      href="https://maps.app.goo.gl/SprrsjCeG2bzcwxh9?g_st=ic"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button>Get Directions</button>
    </a>
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

     
    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <!-- <span style="color: black; font-size: 24px;">CLUTCH</span> -->
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  /* css for footer */
  .bottom-left-textc {
    font-size: 48px;
    margin-top: 120px;
    font-weight: bold;
  }

  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }

      .text-overlay h2 {
    color: white;
      }

  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    z-index: 10;
    background-color: #333333;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }

  /* ----------------------------------------------------- */
  .card-container1 {
    display: flex;
    justify-content: flex-start;
    margin-top: 40px;
    padding-bottom: 80px;
    padding-left: 40px;
    position: relative;
  }

  .card1 {
    width: 20%; /* Adjusted width */
    height: 300px; /* Increased height */
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Adjusted alignment */
    position: relative;
  }

  /* Add vertical lines between cards */
  .card1:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 0;
    right: -10px; /* Adjust this value for spacing between cards */
    width: 1px;
    height: 100%;
    background-color: #ccc;
  }

  .card1 h2 {
    text-align: left;
    font-size: 1.7rem;
    margin-bottom: 0px; /* Add margin bottom */
    color: #333333;
    font-family: BreeSerif;
  }

  .card1 h4 {
    margin-top: 5px;
    color: #333333;
    font-family: SourceSans;
    margin-bottom: 0px;
  }

  .card1 p {
    text-align: left;
    font-size: 1.3rem;
    color: #333333;
    font-family: SourceSans;
    margin-top: 0px;
    margin-bottom: 10px; /* Add margin bottom */
  }

  .card1 button {
    background: none;
    border: none;
    color: #dc1f26;
    text-align: left;
    font-size: 1rem;
    position: relative;
    cursor: pointer;
    padding-bottom: 5px;
    display: inline-block; /* Added */
  }

  .card1 button::after {
    content: "";
    display: block; /* Changed to block */
    width: auto; /* Set width to auto */
    height: 2px;
    background-color: gray;
    position: absolute; /* Changed to absolute */
    bottom: -3px; /* Adjust this value to position the line */
    left: 0; /* Adjusted positioning */
    right: 0; /* Adjusted positioning */
    transition: background-color 0.3s ease; /* Added transition effect */
  }
  .card1 button:hover {
    color: #dc1f26;
  }
  .card1 button:hover::after {
    background-color: #dc1f26;
  }
  .ho3 {
    background: rgb(255, 255, 255);
    height: 400px;
    position: relative;
    width: 100%;

    display: flex;
    overflow: hidden;
  }

  .content {
    margin-top: 100px;
    width: 60%;
    color: rgb(20, 20, 20);
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .right23 {
    width: 40%;
    position: relative;
    height: 100%;
    top: 0;
    overflow: hidden;
    margin-right: 10px;
  }

  #scrollingImage {
    position: absolute;
    top: 0; /* Move the image to the top */
    left: 90%;
    transform: translateX(-100%); /* Scale the image up */
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the container */
  }

  .content h2 {
    font-size: 65px;
    margin-top: 0;
    margin-bottom: 10px;
    color: #333333;
    font-family: BreeSerif;
  }

  .content p {
    font-size: 18px;
    color: gray;
    margin-top: 10px;
    font-family: SourceSans;
  }

  .bottom-left-text {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
  }

  .serv1 {
    text-align: center;
    margin-bottom: 40px;
    width: 100%; /* Full width */
    height: 100vh;
    position: relative; /* For positioning the content */
  }

  .image-container1 {
    width: 100%;
    height: 100%; /* Full height minus navbar height */
    object-fit: cover;
    overflow: hidden;
  }
  .image-container1 img {
    width: 100%;
  }

  .content1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    text-align: center;
    color: white;
    z-index: 1; /* Ensure content is above the image */
    padding: 0 20px; /* Padding for better readability */
  }

  .services-heading {
    color: white;
    font-size: 0.7rem;
    background-color: rgba(
      207,
      209,
      211,
      0.7
    ); /* Semi-transparent background */
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
    margin-top: 30px;
  }

  h1 {
    color: white;
    font-size: 65px;
    font-family: BreeSerif;
    margin-bottom: 5px;
  }

  .lefc {
    text-align: left;
    margin-left: 30px;
    width: 40%;
  }

  .lefc,
  .rightc {
    flex: 1;
  }

  .contact-info-container {
    display: flex;
    justify-content: center;
    margin-top: 20px; /* Space out the contact info */
  }

  .services-description {
    color: white; /* Ensure text is visible over the image */
    font-size: 1.2rem;
  }

  .rightc {
    width: 40%;
    text-align: left;
    margin-right: 20px;
  }

  .contact-info {
    font-weight: bold;
  }

  /* .bu {
    background-color: #054f76;
    color: white;
    padding: 10px 20px;
    font-size: 1.2rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px; 
  } */
  .bu {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .bu::before,
  .bu::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .bu::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .bu::after {
    right: 50%;
    transform: translateX(50%);
  }

  .bu:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .bu:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .bu:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  .container {
    margin-top: 30px;
    display: flex;
    width: 95%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    position: relative;
  }
  /* 
  .full-width {
    width: 100%;
    height: 100%;
    object-fit: cover;
  } */
  @media (max-width: 480px) {
    .serv1 {
      color: #333333;
      width: 100%;
      height: auto; /* Adjust height to auto */
      padding: 0px 0px; /* Add padding */
      margin-top: 17%;
    }

    .image-container1 {
      height: 100%; /* Adjust height */
    }

    .content1 {
      position: static; /* Make content static */
      transform: none; /* Remove transform */
      width: 100%; /* Full width */
      color: black; /* Change text color to black */
      padding: 0px 1px; /* Add padding */
    }

    .services-heading {
      margin-top: 0px;
      margin-bottom: 0px;
      color: #333333;
      font-size: 1rem; /* Adjust font size */
    }

    h1 {
      margin-top: 0px;
      margin-bottom: 0px;

      color: #333333;
      font-size: 40px; /* Adjust font size */
    }

    .contact-info-container {
      margin-top: 0px;
      margin-bottom: 0px;
      color: #333333;
      flex-direction: column; /* Stack contact info vertically */
    }

    .lefc,
    .rightc {
      color: #333333;
      width: 100%; /* Full width */
      text-align: center; /* Center text */
      margin: 10px 0; /* Add margin */
    }

    .services-description {
      margin-bottom: 10px;
      margin-top: 0px;
      color: #333333;
      font-size: 1.1rem; /* Adjust font size */
    }

    .bu {
      font-size: 14px; /* Adjust font size */
      padding: 10px 20px; /* Adjust padding */
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      padding: 0px;
    }

    .content {
      width: 100%;
      text-align: center;
      padding-left: 0;
      margin-right: 0px;
      margin-top: 0;
    }

    .content h2 {
      font-size: 40px;
    }

    .content p,
    .bottom-left-text {
      font-size: 16px;
    }

    .right23 {
      display: none;
    }
    .card-container1 {
      margin-bottom: 0px;
      padding-bottom: 0px;
      flex-direction: column; /* Stack cards vertically */
      align-items: center; /* Center align the cards */
    }

    .card1 {
      width: 90%; /* Full width with margin */
      margin: 0px 0px; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 15px; /* Adjust padding */
    }

    .card1 i {
      font-size: 50px; /* Smaller font size */
    }

    .card1 h2 {
      font-size: 1.4rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.1rem; /* Adjust font size */
    }
    .card1 h4 {
      margin-bottom: 2%;
    }
    .card1:not(:last-child)::after {
      display: none;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
          color: white;
      }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
      margin-top: 0px;
      padding-top: 10px;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 0px;
      padding-top: 0px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
      margin-top: 0px;
      padding-top: 0px;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }

  /* Media query for max-width 768px */
  @media (min-width: 481px) and (max-width: 768px) {
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
          color: white;
      }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
    .card1 {
      width: 45%; /* Adjust width */
      margin: 10px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 18px; /* Adjust padding */
    }

    .card1 i {
      font-size: 60px; /* Adjust font size */
    }
    .card1 h4 {
      margin-bottom: 2%;
    }
    .card1 h2 {
      font-size: 1.5rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.2rem; /* Adjust font size */
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      padding: 0px;
    }

    .content {
      width: 100%;
      text-align: center;
      padding-left: 0;
      margin-top: 0;
    }

    .content h2 {
      font-size: 50px;
    }

    .content p,
    .bottom-left-text {
      font-size: 16px;
    }

    .right23 {
      display: none;
    }
    .serv1 {
      color: #333333;
      height: auto; /* Adjust height to auto */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .image-container1 {
      height: auto; /* Adjust height */
      margin-top: 20px; /* Add margin to the top of the image */
    }

    .content1 {
      position: static; /* Make content static */
      transform: none; /* Remove transform */
      width: 100%; /* Full width */
      color: black; /* Change text color to black */
      padding: 20px 0px; /* Add padding */
    }

    .services-heading {
      color: #333333;
      font-size: 1rem; /* Adjust font size */
    }

    h1 {
      color: #333333;
      font-size: 40px; /* Adjust font size */
    }

    .contact-info-container {
      color: #333333;
      flex-direction: column; /* Stack contact info vertically */
    }

    .lefc,
    .rightc {
      color: #333333;
      width: 100%; /* Full width */
      text-align: center; /* Center text */
      margin: 10px 0; /* Add margin */
    }

    .services-description {
      color: #333333;
      font-size: 1.1rem; /* Adjust font size */
    }

    .bu {
      font-size: 16px; /* Adjust font size */
      padding: 12px 24px; /* Adjust padding */
    }
  }

  /* Media query for min-width 769px and max-width 1025px */
  @media (min-width: 769px) and (max-width: 1025px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .ho3 {
      height: auto;
      padding: 0px 0px;
    }

    .content {
      width: 100%;
      text-align: center;
      padding-left: 0;
      margin-top: 0;
    }

    .content h2 {
      font-size: 55px;
    }

    .content p,
    .bottom-left-text {
      font-size: 18px;
    }

    .right23 {
      display: none;
    }
    .serv1 {
      color: #333333;
      height: auto; /* Adjust height to auto */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .image-container1 {
      height: auto; /* Adjust height */
      margin-top: 20px; /* Add margin to the top of the image */
    }

    .content1 {
      position: static; /* Make content static */
      transform: none; /* Remove transform */
      width: 100%; /* Full width */
      color: black; /* Change text color to black */
      padding: 20px 0px; /* Add padding */
    }

    .services-heading {
      color: #333333;
      font-size: 1.2rem; /* Adjust font size */
    }

    h1 {
      color: #333333;
      font-size: 50px; /* Adjust font size */
    }

    .contact-info-container {
      color: #333333;
      flex-direction: column; /* Stack contact info vertically */
      align-items: center; /* Center align items */
      justify-content: center; /* Center justify items */
    }

    .lefc,
    .rightc {
      color: #333333;
      width: 100%; /* Full width */
      text-align: center; /* Center text */
      margin: 10px 0; /* Add margin */
    }

    .services-description {
      color: #333333;
      font-size: 1.2rem; /* Adjust font size */
    }

    .bu {
      font-size: 18px; /* Adjust font size */
      padding: 14px 28px; /* Adjust padding */
    }
  }

  /* Media query for min-width 1024px and max-width 1324px */
  @media (min-width: 1024px) and (max-width: 1324px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .ho3 {
      height: auto;
      padding: 0px 0px;
    }

    .content {
      width: 100%;
      text-align: center;
      padding-left: 0;
      margin-top: 0;
    }

    .content h2 {
      font-size: 60px;
    }

    .content p,
    .bottom-left-text {
      font-size: 20px;
    }

    .right23 {
      display: none;
    }
    .serv1 {
      color: #333333;
      height: auto; /* Adjust height to auto */
      padding: 0px 0px; /* Add padding */
    }

    .image-container1 {
      height: auto; /* Adjust height */
      margin-top: 20px; /* Add margin to the top of the image */
    }

    .content1 {
      position: static; /* Make content static */
      transform: none; /* Remove transform */
      width: 100%; /* Full width */
      color: black; /* Change text color to black */
      padding: 20px 0px; /* Add padding */
    }

    .services-heading {
      color: #333333;
      font-size: 1.3rem; /* Adjust font size */
    }

    h1 {
      color: #333333;
      font-size: 60px; /* Adjust font size */
    }

    .contact-info-container {
      color: #333333;
      flex-direction: column; /* Stack contact info vertically */
      align-items: center; /* Center align items */
      justify-content: center; /* Center justify items */
    }

    .lefc,
    .rightc {
      flex: 1;
      color: #333333;
      width: 100%; /* Full width */
      text-align: center; /* Center text */
      margin: 10px 0; /* Add margin */
    }

    .services-description {
      color: #333333;
      font-size: 1.3rem; /* Adjust font size */
    }

    .bu {
      font-size: 20px; /* Adjust font size */
      padding: 16px 30px; /* Adjust padding */
    }
  }
</style>
